import { eAtlas, eUIAtlasFrame, Game } from "../../../../Game";
import { AtlasUtils } from "../../../../Utils/Atlas/AtlasUtils";
import { Gameplay, TIMER } from "../../../Gameplay";
import { Ball } from "../../../Player/Ball";



export class FireBallBar {
    // O kolik se znmeni hodnota baru za vterinu pri plneni baru
    private static readonly FILL_SPEED = 1;
    // O kolik se znmeni hodnota baru za vterinu pri vyprazdnovani baru
    private static readonly EMPTY_SPEED = 2;

    private _container: pc.Entity;

    private _fillEnt: pc.Entity;
    private _fillFrameRc: pc.Vec4 = new pc.Vec4();
    private _fillFrameRcW: number;
    private _fillFramePixW: number;
    private _curFillState: number;
    private _tarFillState: number;

    private _flames: Flames;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.Entity, batchGroupId: number) {
        let atlas = Game.getAtlas(eAtlas.ui);

        // Pozadi pruhu
        let atlasRc = (atlas.frames[eUIAtlasFrame.fireBallBarBg] as pc.TextureAtlasFrame).rect;
        let texRc = AtlasUtils.getTexFrameRegion(atlas.texture, atlasRc);

        this._container = new pc.Entity();
        this._container.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: atlasRc.z,
            height: atlasRc.w,
            anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
            pivot: new pc.Vec2(0.5, 0.5),
            rect: texRc,
            batchGroupId: batchGroupId
        });

        parent.addChild(this._container);

        // Vypln pruhu
        atlasRc = (atlas.frames[eUIAtlasFrame.fireBallBarFill] as pc.TextureAtlasFrame).rect;
        AtlasUtils.getTexFrameRegion(atlas.texture, atlasRc, this._fillFrameRc);

        this._fillFramePixW = atlasRc.z;
        this._fillFrameRcW = this._fillFrameRc.z;

        this._fillEnt = new pc.Entity();
        this._fillEnt.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: 0,
            height: atlasRc.w,
            anchor: new pc.Vec4(0, 0.5, 0, 0.5),
            pivot: new pc.Vec2(0, 0.5),
        });

        this._container.addChild(this._fillEnt);

        // Zachytavat zmenu stavu fire ballu
        Gameplay.instance.events.on(Ball.EVENT_FIRE_BALL_STATE_CHANGE, this.handleFireBallStateChange, this);

        // Animace plamenu
        this._flames = new Flames(this._container);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._fillFrameRc.z = 0;
        this._fillEnt.element.rect = this._fillFrameRc;
        this._fillEnt.element.width = 0;
        this._curFillState = this._tarFillState = 0;

        this._flames.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._curFillState != this._tarFillState) {
            if (this._curFillState < this._tarFillState) {
                this._curFillState += FireBallBar.FILL_SPEED * TIMER.deltaS;

                if (this._curFillState > this._tarFillState)
                    this._curFillState = this._tarFillState;
            }
            else {
                this._curFillState -= FireBallBar.EMPTY_SPEED * TIMER.deltaS;

                if (this._curFillState < this._tarFillState)
                    this._curFillState = this._tarFillState;
            }

            this._fillFrameRc.z = this._fillFrameRcW * this._curFillState;
            this._fillEnt.element.rect = this._fillFrameRc;
            this._fillEnt.element.width = Math.round(this._fillFramePixW * this._curFillState);

            if (this._curFillState == this._tarFillState)
                this._fillEnt.element.batchGroupId = this._container.element.batchGroupId;
        }

        this._flames.update();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleFireBallStateChange(state: number): void {
        if (state == 1) {
            // Zobrazit plameny
            this._flames.show();
        }
        else if (this._tarFillState == 1) {
            // Skryt plameny
            this._flames.hide();
        }

        this._tarFillState = state;
        this._fillEnt.element.batchGroupId = -1;
    }
}



const enum eFlamesState {
    hiden,
    showing,
    shown,
    hiding
}



class Flames {
    private static readonly FRAME_CNT = 4;
    private static readonly FRAME_TIME = 100;

    private _ent: pc.Entity;
    private _frameId: number;
    private _frameRc: pc.Vec4 = new pc.Vec4();
    private _nextFrameTime: number;

    private _state: eFlamesState;
    private _stateTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.Entity) {
        let atlas = Game.getAtlas(eAtlas.ui);
        let atlasRc = (atlas.frames[eUIAtlasFrame.fireBallBarFlames + 0] as pc.TextureAtlasFrame).rect;

        this._ent = new pc.Entity();
        this._ent.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: atlasRc.z,
            height: atlasRc.w,
            anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
            pivot: new pc.Vec2(0.5, 0.38),
        });

        this._ent.enabled = false;
        parent.addChild(this._ent);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._ent.enabled = false;
        this._state = eFlamesState.hiden;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._state == eFlamesState.hiden)
            return;

        if (TIMER.time >= this._nextFrameTime)
            this.showNextFrame();

        if (this._state == eFlamesState.showing) {
            this.processShowing();
        }
        else if (this._state == eFlamesState.hiding) {
            this.processHiding();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(): void {
        this._frameId = -1;
        this.showNextFrame();

        this._ent.element.opacity = 0;
        this._ent.enabled = true;

        this._state = eFlamesState.showing;
        this._stateTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    hide(): void {
        this._state = eFlamesState.hiding;
        this._stateTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private showNextFrame(): void {
        if (++this._frameId == Flames.FRAME_CNT)
            this._frameId = 0;

        AtlasUtils.getAtlasFrameRegion(Game.getAtlas(eAtlas.ui), eUIAtlasFrame.fireBallBarFlames + this._frameId, this._frameRc);
        this._ent.element.rect = this._frameRc;

        this._nextFrameTime = TIMER.time + Flames.FRAME_TIME;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private processShowing(): void {
        let progress = (TIMER.time - this._stateTime) / 1000;

        if (progress > 1)
            progress = 1;

        this._ent.element.opacity = pc.SineIn(progress);

        if (progress == 1)
            this._state = eFlamesState.shown;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private processHiding(): void {
        let progress = (TIMER.time - this._stateTime) / 1000;

        if (progress >= 1) {
            this._ent.enabled = false;
            this._state = eFlamesState.hiden;
            return;
        }

        this._ent.element.opacity = 1 - pc.SineOut(progress);
    }
}